<template>
  <c-container
    padding-size="small"
    class="settings-page"
  >
    <div :style="{ marginBottom: '2rem' }">
      <h3>
        Account
      </h3>
      <c-form-field label="Email">
        <c-input
          v-model:value="user.email"
          disabled
          show-border
          show-background
        />
      </c-form-field>
      <h3>
        Open AI
      </h3>
      <c-form-field label="Open AI API Key">
        <c-input
          v-model:value="openAIKey"
          show-border
          show-background
          type="password"
        />
        <div :style="{ marginTop: '.6rem', color: $colors.grey.base }">
          You can find your Secret API key in your <a
            class="-underline"
            href="https://platform.openai.com/account/api-keys"
            target="_blank"
          >
            User settings
          </a>
        </div>
      </c-form-field>
      <c-button
        color="primary"
        :style="{ marginTop: '2rem' }"
        @click="saveSettings"
      >
        Save
      </c-button>

      <h3>Plans</h3>
      <c-card padding>
        <div :style="{ display: 'flex' }">
          <div :style="{ display: 'flex' }">
            <div>
              <img :src="currentPlan.icon.src">
              <div :style="{ fontSize: $fontSizes[6], fontWeight: 'bold' }">
                {{ currentPlan.title }}
              </div>
              <div>
                <template v-if="currentPlan.id === plans.free.id">
                  $0 / month
                </template>
                <template v-else>
                  ${{ currentPlan.price }} / month
                </template>
              </div>
            </div>
            <div>
              <div :style="{ marginLeft: '2rem' }">
                <div>
                  <div :style="{ fontWeight: '500'}">
                    Includes:
                  </div>
                  <ul
                    v-for="(benefit, index) in currentPlan.benefits"
                    :key="index"
                    :style="{ color: $colors.grey.darken1, marginBlockStart: '.2rem', paddingInlineStart: '2rem', marginBlockEnd: 0 }"
                  >
                    <li>
                      {{ benefit.text }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :style="{ marginTop: '2rem' }">
          <c-button
            :color="currentPlan.id === plans.free.id ? 'primary' : ''"
            outlined
            :href="upgradeUrl"
            target="_blank"
          >
            <template v-if="currentPlan.id === plans.free.id">
              Upgrade
            </template>
            <template v-else>
              Manage
            </template>
          </c-button>
        </div>
      </c-card>
    </div>
  </c-container>
</template>

<script>
import CButton from 'shared/components/CButton.vue';
import CCard from 'shared/components/CCard.vue';
import CContainer from 'shared/components/CContainer.vue';
import CFormField from 'shared/components/CFormField.vue';
import CInput from 'shared/components/CInput.vue';
import { BETA_PHASE_MANAGER, plans, SETTINGS_SERVICE, USER_SERVICE } from 'shared/constants';
import useSubscription from 'shared/services/subscription';
import { inject, ref } from 'vue';

export default {
  name: 'SettingsPage',
  setup() {
    const settingsService = inject(SETTINGS_SERVICE);
    const userService = inject(USER_SERVICE);
    const betaPhaseManager = inject(BETA_PHASE_MANAGER);
    const { currentPlan } = useSubscription(userService.currentUser, betaPhaseManager);
    const openAIKey = ref('');
    if (settingsService.settings.value.openAIKey !== undefined) {
      openAIKey.value = settingsService.settings.value.openAIKey;
    }
    return { currentPlan, settingsService, openAIKey, user: userService.currentUser };
  },
  components: { CContainer, CFormField, CInput, CButton, CCard },
  data() {
    return { plans };
  },
  computed: {
    upgradeUrl() {
      return `${import.meta.env.VITE_WEBSITE_URL}/app/plans`;
    },
  },
  methods: {
    saveSettings() {
      this.settingsService.save({ openAIKey: this.openAIKey });
      this.$eventBus.emit('show-toast', {
        message: 'Successfully saved.',
        type: 'success',
      });
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  ._pricing-table {
    padding: 0 2rem 2rem;
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr 1fr 1fr;
    overflow-x: auto;
  }
</style>
